module.exports = __webpack_public_path__ + "img/weights.9b0c92f1.jpg";